module.exports = __webpack_public_path__ + "static/media/02.878f0503.jpg";